import React from "react";
import styled from "styled-components";
import { Container } from "reactstrap";
import PatreonButton from "./PatreonButton"
import PayPalButton from "./PayPalButton"
import StarCitizenReferralButton from "./StarCitizenReferralButton"

const Footer = styled.footer`
    padding: 40px 0 70px 0;
    background: #4e5944;
    color: white;
`;

const CopyrightText = styled.div`
    margin-bottom: 20px;
    display: inline-block;
`;

const SupportButtons = styled.div`
    @media (min-width: 768px) {
        float: right;
    }
`;

const SiteFooter = () => (
    <Footer>
        <Container>
            <CopyrightText>
                &copy; Copyright 2020 <a href="http://www.imbick.com/">Imbick</a>
            </CopyrightText>
            <SupportButtons>
                <PatreonButton userId="30704489" />
                <PayPalButton />
                <StarCitizenReferralButton referralCode="STAR-LXP3-DQWD" />
            </SupportButtons>
        </ Container>
    </Footer>
);

export default SiteFooter;